export default class Notice {
    constructor() {
        this.el = false;
        this.timeout = false;
    }

    initNotice(message, status = 'success') {
        if (this.el) {
            this.close(false);
        }

        this.render(message, status);
        this.bindEvents();
    }

    initTimeout() {
        if (this.timeout) return;

        this.timeout = setTimeout(() => {
            if (this.el) {
                this.close();
            }
        }, 4000);
    }

    bindEvents() {
        this.el = document.querySelector('.notice');
        this.el.addEventListener('click', () => this.close());

        this.initTimeout();
    }

    close(animation = true) {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = false;
        }

        this.removeEl(animation);
    }

    removeEl(animation = true) {
        if (!this.el) return;

        this.el.classList.add('animate-out');
        if (!animation) {
            this.el.remove();
            this.el = false;
        } else {
            setTimeout(() => {
                if (this.el) {
                    this.el.remove();
                    this.el = false;
                }
            }, 250);
        }
    }

    render(text, status) {
        const html =
         `
         <div class="notice primaryBackground notice--${status}">
             <p class="notice__inner">${text}</p>
         </div>
         `;
        document.body.insertAdjacentHTML('beforeend', html);
    }
}



// WEBPACK FOOTER //
// ./src/components/notice/notice.js